// extracted by mini-css-extract-plugin
module.exports = {"heading":"followers_heading__lSA4I","content":"followers_content__2B6vD","button":"followers_button__3R2mn","sending":"followers_sending__2ajQZ"};